const MONTHS = [
  'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
  'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря',
]

/**
 * ISO-дату из JSON выводим по-русски: «24 августа 2026 г.»
 *
 * Намеренно без `toLocaleDateString`: тот зависит от локали браузера,
 * и у посетителя с английской системой юридический документ показал бы
 * «August 24, 2026». Дата в таком документе должна быть стабильной.
 *
 * При неожиданном формате возвращает исходную строку — опечатка в JSON
 * не должна ронять страницу.
 */
export function formatRuDate(iso: string): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso)
  if (!match) return iso

  const [, year, month, day] = match
  const name = MONTHS[Number(month) - 1]
  if (!name) return iso

  return `${Number(day)} ${name} ${year} г.`
}
